(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gift-builder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-gift-builder]').forEach(function (form) {
      var totalEl = form.querySelector('[data-gb-total]');
      var msgEl = form.querySelector('[data-gb-msg]');
      var submit = form.querySelector('[data-gb-submit]');
      var fmt = function (cents) {
        try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AED' }).format(cents / 100); }
        catch (e) { return (cents / 100).toFixed(2); }
      };
      function recalc() {
        var total = 0;
        form.querySelectorAll('input[type=radio]:checked').forEach(function (i) { if (i.value) total += parseInt(i.dataset.price || '0', 10); });
        if (totalEl) totalEl.textContent = fmt(total);
      }
      form.addEventListener('change', recalc);
      recalc();
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var items = [];
        form.querySelectorAll('input[type=radio]:checked').forEach(function (i) { if (i.value) items.push({ id: parseInt(i.value, 10), quantity: 1 }); });
        if (!items.length) { if (msgEl) msgEl.textContent = 'Please choose your flowers first.'; return; }
        submit.disabled = true; if (msgEl) msgEl.textContent = 'Adding to your cart…';
        fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            if (!res.ok) { throw new Error((res.d && res.d.description) || 'Could not add to cart'); }
            window.location.href = '/cart';
          })
          .catch(function (err) { submit.disabled = false; if (msgEl) msgEl.textContent = err.message || 'Something went wrong. Please try again.'; });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-finder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-gift-finder]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var data = new FormData(form);
        var occasion = data.get('occasion') || 'all';
        var type = data.get('type') || 'occasion';
        var budget = (data.get('budget') || '0-0').split('-');
        // Resolve target collection
        var handle;
        if (type === 'cakes' || type === 'balloons') handle = type;
        else handle = occasion; // flowers / mix -> occasion collection
        if (!handle || handle === 'occasion') handle = 'all';
        var url = '/collections/' + handle;
        // Native Shopify price filter (AED). 0 means open-ended.
        var params = [];
        var min = parseInt(budget[0], 10) || 0;
        var max = parseInt(budget[1], 10) || 0;
        if (min > 0) params.push('filter.v.price.gte=' + min);
        if (max > 0) params.push('filter.v.price.lte=' + max);
        if (params.length) url += '?' + params.join('&');
        window.location.href = url;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
